import React from "react";
import { createReducer } from "redux-create-reducer";
import { toast } from "react-toastify";
import { NOTIFY_SUCCESS, NOTIFY_ERROR, NOTIFY_WARNING } from "../types";
import CustomToast from "../components/common/CusomToast/CustomToast";

const initialState = { type: "", message: "", toastsIDs: [] };

function keepToastsTwo(currentToastsIds, newToastId) {
  if (currentToastsIds.length >= 2) {
    toast.dismiss(currentToastsIds[0]);
    return [...currentToastsIds.slice(1), newToastId];
  }

  return [...currentToastsIds, newToastId];
}

function checkForDuplicates(currentToastsIds, toastId) {
  // for the reason we want to have 2 endpoints for entries count and for entries
  // this is the cause we have 2 toasts for the same thing
  return currentToastsIds.some((time1) => toastId - time1 < 500);
}

const notificationsReducer = createReducer(initialState, {
  [NOTIFY_SUCCESS]: (state, { payload }) => {
    const toastId = new Date().getTime();
    if (checkForDuplicates([...state.toastsIDs], toastId)) {
      return state;
    }
    const currentIds = keepToastsTwo([...state.toastsIDs], toastId);
    toast.success(<CustomToast payload={payload} type={NOTIFY_SUCCESS} />, {
      position: toast.POSITION.BOTTOM_RIGHT,
      closeOnClick: false,
      autoClose: 10000,
      closeButton: false,
      hideProgressBar: false,
      progressClassName: "success-toast-progress-bar-custom",
      className: "success-toast-custom",
      toastId,
    });
    return { type: "SUCCESS", message: payload, toastsIDs: currentIds };
  },
  [NOTIFY_ERROR]: (state, { payload }) => {
    const toastId = new Date().getTime();
    if (checkForDuplicates([...state.toastsIDs], toastId)) {
      return state;
    }
    const currentIds = keepToastsTwo([...state.toastsIDs], toastId);
    toast.error(<CustomToast payload={payload} type={NOTIFY_ERROR} />, {
      position: toast.POSITION.BOTTOM_RIGHT,
      closeOnClick: false,
      autoClose: 10000,
      closeButton: false,
      hideProgressBar: false,
      progressClassName: "error-toast-progress-bar-custom",
      className: "error-toast-custom",
    });
    return { type: "ERROR", message: payload, toastsIDs: currentIds };
  },
  [NOTIFY_WARNING]: (state, { payload }) => {
    const toastId = new Date().getTime();
    if (checkForDuplicates([...state.toastsIDs], toastId)) {
      return state;
    }
    const currentIds = keepToastsTwo([...state.toastsIDs], toastId);
    toast.warn(<CustomToast payload={payload} type={NOTIFY_WARNING} />, {
      position: toast.POSITION.BOTTOM_RIGHT,
      closeOnClick: false,
      autoClose: 10000,
      closeButton: false,
      hideProgressBar: false,
      progressClassName: "warning-toast-progress-bar-custom",
      className: "warning-toast-custom",
      toastId,
    });
    return { type: "WARN", message: payload, toastsIDs: currentIds };
  },
});

export default notificationsReducer;



// WEBPACK FOOTER //
// ./src/reducers/notificationsReducer.js